import { render, staticRenderFns } from "./SampleImg.vue?vue&type=template&id=c07ec994&scoped=true&"
import script from "./SampleImg.vue?vue&type=script&lang=js&"
export * from "./SampleImg.vue?vue&type=script&lang=js&"
import style0 from "./SampleImg.vue?vue&type=style&index=0&id=c07ec994&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c07ec994",
  null
  
)

export default component.exports